import { createEvent } from "effector";
import { ILoginFormStore } from "./types";


export const setInputValue = createEvent<{ key: keyof ILoginFormStore, value: string }>();

export const login = createEvent();

export const changePasswordInputType = createEvent<{
    key: keyof ILoginFormStore,
    type: React.HTMLInputTypeAttribute
}>();

export const setLoginFormStore = createEvent<ILoginFormStore>();

export const resetErrors = createEvent<keyof ILoginFormStore>();
